// 💾 src/pages/client/sections/components/Profile/Verification.tsx
import { useEffect, useState } from "react"
import { auth, db } from "../../../../../services/firebase"
import { doc, getDoc } from "firebase/firestore"
import "./style/Verification.scss"

const Verification = () => {
  const [kyc, setKyc] = useState<any>(null)
  const [loading, setLoading] = useState(true)

  const user = auth.currentUser

  useEffect(() => {
    const fetchKyc = async () => {
      if (!user) return
      const ref = doc(db, "users", user.uid)
      const snap = await getDoc(ref)
      if (snap.exists()) {
        setKyc(snap.data().kyc || null)
      }
      setLoading(false)
    }
    fetchKyc()
  }, [user])

  return (
    <div className="verification-page">
      <h2>Identification</h2>

      <div className="card verified">
        <div>
          <h3>Advanced KYC</h3>
          <p>More benefits, enhanced security, and higher trading limits</p>
        </div>
        <div className="status">✅ Verified</div>
      </div>

      <div className="card level">
        <h4>Account Benefits</h4>
        <ul>
          <li>KYC Level: <span>Advanced KYC</span></li>
          <li>Crypto Deposit: <span>Unlimited</span></li>
          <li>Crypto Withdraw: <span>200 BTC / day</span></li>
          <li>Fiat Trading: <span>Yes</span></li>
          <li>Spot/Futures Trading: <span>Enabled</span></li>
        </ul>
      </div>

      <div className="card kyc-info">
        <h4>My KYC Details</h4>
        {loading ? (
          <p>Loading...</p>
        ) : kyc ? (
          <ul>
            <li>Country/Region: <span>{kyc.country || "N/A"}</span></li>
            <li>Name: <span>{kyc.name || "N/A"}</span></li>
            <li>ID Type: <span>{kyc.type || "N/A"}</span></li>
            <li>ID Number: <span>{kyc.id || "N/A"}</span></li>
            <li>Birth Date: <span>{kyc.dob || "N/A"}</span></li>
          </ul>
        ) : (
          <p className="info">
            Your KYC is approved manually. Please send required documents to <strong>support@my-exchange.com</strong>. Our team will verify it shortly.
          </p>
        )}
      </div>

      <div className="card faq">
        <h4>Frequently Asked Questions (FAQ)</h4>
        <details>
          <summary>Why is KYC verification necessary?</summary>
          <p>KYC helps prevent fraud and ensures compliance with global regulations.</p>
        </details>
        <details>
          <summary>How to complete personal KYC verification?</summary>
          <p>Please send your ID and proof of address to support@my-exchange.com.</p>
        </details>
        <details>
          <summary>What documents can I use to complete KYC verification?</summary>
          <p>Passport, National ID, or Driver’s License and utility bill or bank statement.</p>
        </details>
        <details>
          <summary>Why did my KYC verification fail?</summary>
          <p>Invalid or unclear documents, or country not supported.</p>
        </details>
      </div>
    </div>
  )
}

export default Verification
